import type { AuthUser } from "../../types/auth";
import { hasPermission } from "../../lib/permissions";
import { FORM_IDS, PROCESS_IDS } from "../../lib/permissionCatalog";

export function canAccessAudit(user: AuthUser | null | undefined): boolean {
  return (
    user?.type === "office" &&
    hasPermission(user, {
      forms: [FORM_IDS.AUDIT],
      processes: [PROCESS_IDS.AUDIT_VIEW],
    })
  );
}
